import { lazy } from 'react'
import { Upload } from 'lucide-react'

import { HIERARCHY_PERMISSIONS, SETTING_PERMISSIONS } from '@/lib/permissions'
import { CONTENT_UPLOAD_POLICY_TYPE } from '../../api/content-upload-policy-api'
import type { PolicyKindContribution } from './policy-kind'

export const contentUploadPolicyKind = {
  valueType: CONTENT_UPLOAD_POLICY_TYPE,
  label: 'Maximum upload size',
  description: 'Limit content file sizes at matching entities.',
  icon: Upload,
  order: 30,
  readPermission: HIERARCHY_PERMISSIONS.read,
  managePermission: SETTING_PERMISSIONS.edit,
  create: lazy(() => import('./create-content-upload-policy').then((module) => ({
    default: module.CreateContentUploadPolicy,
  }))),
  list: lazy(() => import('./content-upload-policy-list').then((module) => ({
    default: module.ContentUploadPolicyList,
  }))),
} satisfies PolicyKindContribution
